<template>
	<div>
		<div class="card__title">
			<h5>Utilidades</h5>
		</div>
		<div class="card__content">
			<div class="row">
				<div class="col-xs-12">
					<div class="table-responsive">
						<table>
							<thead>
								<tr>
									<th>Nombre</th>
									<th>Porcentaje</th>
									<th>Desde</th>
									<th>Hasta</th>
									<th>
										<button @click="agregarComision()" type="button" class="btn-success">
											<i class="fa fa-plus"></i>
										</button>
									</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(comision, key) in form.comisiones" :key="key">
									<td>
										<div class="form-field">
											<input-field v-model="comision.nombre" :id="'nombre'[key]" placeholder="Escriba un nombre..." type="text">
												<span v-if="errores.comisiones[key] != null && errores.comisiones[key].nombre != null" class="helper-text text-danger" slot="helper">
													{{ errores.comisiones[key].nombre }}
												</span>
											</input-field>
										</div>
									</td>
									<td>
										<div class="form-field">
											<input-field v-model="comision.porcentaje" vMoney :format="porcentaje" :id="'porcentaje'[key]" placeholder="" type="tel">
												<span v-if="errores.comisiones[key] != null && errores.comisiones[key].porcentaje != null" class="helper-text text-danger" slot="helper">
													{{ errores.comisiones[key].porcentaje }}
												</span>
											</input-field>
										</div>
									</td>
									<td>
										<div class="form-field">
											<input-field v-model="comision.valor_desde" vMoney :format="money" :id="'valor_desde'[key]" placeholder="" type="tel">
												<span v-if="errores.comisiones[key] != null && errores.comisiones[key].valor_desde != null" class="helper-text text-danger" slot="helper">
													{{ errores.comisiones[key].valor_desde }}
												</span>
											</input-field>
										</div>
									</td>
									<td>
										<div class="form-field">
											<input-field v-model="comision.valor_hasta" vMoney :format="money" :id="'valor_hasta'[key]" placeholder="" type="tel">
												<span v-if="errores.comisiones[key] != null && errores.comisiones[key].valor_hasta != null" class="helper-text text-danger" slot="helper">
													{{ errores.comisiones[key].valor_hasta }}
												</span>
											</input-field>
										</div>
									</td>
									<td>
										<button @click="eliminarFila(key)" type="button" class="btn-danger">
											<i class="fa fa-trash"></i>
										</button>
									</td>
								</tr>
								<tr v-show="form.comisiones.length <= 0">
									<td colspan="5">
										<strong>No hay campos</strong>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	props: {
		comisionesUtilidades: {
			type: Array,
			default: () => [],
		},
		erroresComisionesUtilidades: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {
			porcentaje,
			money,
			form: {
				comisiones: this.comisionesUtilidades,
			},
			errores: {
				comisiones: this.erroresComisionesUtilidades,
			},
		}
	},
	methods: {
		eliminarFila: function (index) {
      this.form.comisiones.splice(index, 1);
      this.errores.comisiones.splice(index, 1);
    },
		agregarComision: function(){
			this.errores.comisiones.forEach(error => {
				if (error.nombre != '' && error.porcentaje != '' && error.valor_desde != '' && error.valor_hasta != '') {
					error.nombre = null;
					error.porcentaje = null;
					error.valor_desde = null;
					error.valor_hasta = null;
				}
			});
			let ultimoItem = this.form.comisiones[this.form.comisiones.length - 1];
			if (ultimoItem == undefined || (ultimoItem.nombre != '' && ultimoItem.porcentaje != '' && ultimoItem.valor_desde != '' && ultimoItem.valor_hasta != '' &&
				parseFloat(ultimoItem.porcentaje) > 0 && parseFloat(ultimoItem.valor_desde) > 0 && parseFloat(ultimoItem.valor_hasta) > 0 &&
				parseFloat(ultimoItem.valor_desde) <= 9999999999999.99 && parseFloat(ultimoItem.valor_hasta) <= 9999999999999.99 &&
				parseFloat(ultimoItem.valor_desde) < parseFloat(ultimoItem.valor_hasta))
			) {
					this.form.comisiones.push({
						selectedCategorias: [],
						nombre: '',
						porcentaje: '',
						valor_desde: '',
						valor_hasta: '',
					});
					this.errores.comisiones.push({
						nombre: null,
						porcentaje: null,
						valor_desde: null,
						valor_hasta: null,
					});
			}
			else {
				if (this.form.comisiones.length > this.errores.comisiones.length) {
					this.errores.comisiones.push({
						nombre: null,
						porcentaje: null,
						valor_desde: null,
						valor_hasta: null,
					});
				}
				else if (this.form.comisiones.length >= this.errores.comisiones.length) {
					this.errores.comisiones[this.errores.comisiones.length - 1].nombre = null;
					this.errores.comisiones[this.errores.comisiones.length - 1].porcentaje = null;
					this.errores.comisiones[this.errores.comisiones.length - 1].valor_desde = null;
					this.errores.comisiones[this.errores.comisiones.length - 1].valor_hasta = null;
				}
				if (ultimoItem.nombre == '')
					this.errores.comisiones[this.errores.comisiones.length - 1].nombre = "El campo es requerido.";
				if (ultimoItem.porcentaje == '' || parseFloat(ultimoItem.porcentaje) <= 0)
					this.errores.comisiones[this.errores.comisiones.length - 1].porcentaje = "El campo es requerido.";
				if (ultimoItem.valor_desde == '' || parseFloat(ultimoItem.valor_desde) <= 0)
					this.errores.comisiones[this.errores.comisiones.length - 1].valor_desde = "El campo es requerido.";
				if (ultimoItem.valor_hasta == '' || parseFloat(ultimoItem.valor_hasta) <= 0)
					this.errores.comisiones[this.errores.comisiones.length - 1].valor_hasta = "El campo es requerido.";
				if(parseFloat(ultimoItem.valor_desde) > 9999999999999.99)
					this.errores.comisiones[this.errores.comisiones.length - 1].valor_desde = "El campo no puede ser mayor a 9999999999999.99.";
				if(parseFloat(ultimoItem.valor_hasta) > 9999999999999.99)
					this.errores.comisiones[this.errores.comisiones.length - 1].valor_hasta = "El campo no puede ser mayor a 9999999999999.99.";
				if(parseFloat(ultimoItem.valor_desde) >= parseFloat(ultimoItem.valor_hasta))
					this.errores.comisiones[this.errores.comisiones.length - 1].valor_desde = "El campo no puede ser mayor o igual al campo 'Hasta'.";
			}
		},
	},
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/mantenimiento/parametrizacion/comisiones/ComisionUtilidad.vue